import FullscreenView from "../../components/ComponentLibrary/FullscreenView";

const FullscreenViewPage = () => {
	return (
		<div className="w-full flex flex-col gap-y-8 flex-wrap items-center justify-center page-transition">
			<div className="max-w-3xl text-center space-y-4">
				<div className="space-y-3">
					<div className="flex items-center justify-center gap-2 mb-2">
						<div className="w-1 h-1 rounded-full bg-amber-400 animate-pulse"></div>
						<span className="text-xs uppercase tracking-widest text-amber-400 font-semibold">Component #90</span>
						<div className="w-1 h-1 rounded-full bg-amber-400 animate-pulse"></div>
					</div>
					<h1 className="text-5xl font-bold bg-gradient-to-r from-amber-400 via-blue-400 to-amber-400 bg-clip-text text-transparent">
						Fullscreen View
					</h1>
				</div>
				<p className="text-slate-400 text-base md:text-lg leading-relaxed">
					Fullscreen overlay modal view.
				</p>
			</div>
			<div className="hover-lift">
				<FullscreenView />
			</div>
		</div>
	);
};

export default {
	page: FullscreenViewPage,
};

